import { createFileRoute } from '@tanstack/react-router'
import ChatAdmin from '@/features/chadmin'

export const Route = createFileRoute('/_authenticated/chadmin/')({
  component: ChatAdmin,
})
